import { render, staticRenderFns } from "./NftCard.vue?vue&type=template&id=ec6e280e&scoped=true&lang=pug"
import script from "./NftCard.vue?vue&type=script&lang=js"
export * from "./NftCard.vue?vue&type=script&lang=js"
import style0 from "./NftCard.vue?vue&type=style&index=0&id=ec6e280e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6e280e",
  null
  
)

export default component.exports